<template>
  <div class="app-container post-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="post-detail-item">
            <el-col :span="3">标题:</el-col>
            <el-col :span="16">{{ postDetail.title | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">标题（英文）:</el-col>
            <el-col :span="16">{{ postDetail.titleEn | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="post-detail-item" >
            <el-col :span="3">内容素材:</el-col>
            <el-col :span="16">
              <div class="post-cover-image" v-if="postDetail.coverImg && !isVideo">
              <viewer>
                <img v-for="src in postDetail.photos" :src="src" :key="src">
              </viewer>
              </div>
              <div class="post-content-video" v-if="postDetail.coverImg && isVideo">
                <img :src="postDetail.coverImg" @click="viewVideo()">
                <i class="icon-content-play"></i>
              </div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item post-content-text">
            <el-col :span="3">正文:</el-col>
            <el-col :span="16">
              <div v-if="postDetail.contentType == 1">
                <div v-html="postDetail.content"></div>
              </div>
              <div v-else>{{ postDetail.content | formatDefaultlVal }}</div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item post-content-text">
            <el-col :span="3">正文（英文）:</el-col>
            <el-col :span="16">
              <div v-if="postDetail.contentType == 1">
                <div v-html="postDetail.contentEn"></div>
              </div>
              <div v-else>{{ postDetail.contentEn | formatDefaultlVal }}</div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">官方号名称:</el-col>
            <el-col :span="16">
              {{ postDetail.postedByName }}
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">发布者姓名:</el-col>
            <el-col :span="16">
              {{ postDetail.postedByRealname }}
            </el-col>
          </el-row>
          <el-row class="post-detail-item" v-if="isGlobal">
            <el-col :span="3">分类:</el-col>
            <el-col :span="16">{{ postDetail.parentTags | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="post-detail-item" v-if="isGlobal">
            <el-col :span="3">话题:</el-col>
            <el-col :span="16">{{ postDetail.tags | formatDefaultlVal }}</el-col>
          </el-row>
          <!-- <el-row class="post-detail-item" v-if="isGlobal">
            <el-col :span="3">链接:</el-col>
            <el-col :span="16" v-if="postDetail.postLinks.length>0">
              <template v-for="(link, index) in postDetail.postLinks">
                <span :key="link.id" @click="clickLink(link.url)" style="cursor:pointer">
                  {{link.text}}{{index!==postDetail.postLinks.length - 1 ? '、' : ''}}
                </span>
              </template>
            </el-col>
            <el-col :span="16" v-else>--
            </el-col>
          </el-row> -->
          <el-row class="post-detail-item" v-if="!isGlobal">
            <el-col :span="3">所属圈子:</el-col>
            <el-col :span="16">{{ postDetail.circleName }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">内容状态:</el-col>
            <el-col :span="16">{{ postDetail.publishStatus }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">下架原因:</el-col>
            <el-col :span="16">{{ postDetail.banComment | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">发布时间:</el-col>
            <el-col :span="16">{{ postDetail.postTime | formatDefaultlVal }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">评论量:</el-col>
            <el-col :span="16">
              {{ postDetail.commentCount }}
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">点赞量:</el-col>
            <el-col :span="16">{{postDetail.likeCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">收藏量:</el-col>
            <el-col :span="16">{{postDetail.favoriteCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="3">浏览量:</el-col>
            <el-col :span="16">{{postDetail.viewedCount}}</el-col>
          </el-row>
          <el-dialog :visible.sync="unhandledVideolsVisible" width="40%" class="handle-dialog" @close="closeVideo">
            <video-player
              class="vjs-mc-skin"
              :playsinline="true"
              :options="postDetail.playerOption"
              ref="videoPlayer">
            </video-player>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="评论列表" name="comment">
          <el-table :data="commentData" stripe tooltip-effect="dark">
            <el-table-column prop="content" label="评论内容" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="commentByName" label="评论人Full Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentByRealname" label="评论人Birth Name" width="140"></el-table-column>
            <el-table-column align="center" prop="commentTime" label="评论时间" width="200"></el-table-column>
            <el-table-column align="center" prop="commentToName" label="回复对象Full Name" width="160"></el-table-column>
            <el-table-column align="center" prop="commentToRealname" label="回复对象Birth Name" width="160"></el-table-column>
            <el-table-column align="center" label="是否已下架" width="100">
              <template slot-scope="scope">
                {{scope.row.isBanned ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="下架原因"  width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.banComment || "--"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini"
                  type="text"
                  icon="el-icon-upload2"
                  title="上架"
                  v-if="permissions.content_list_up && scope.row.isBanned"
                  @click="handleUp(scope.row,scope.index)">上架
                </el-button>
                <el-button size="mini"
                      type="text"
                      icon="el-icon-download"
                      title="下架"
                      v-if="permissions.content_list_down && !scope.row.isBanned"
                      @click="handleDown(scope.row,scope.index)">下架
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :page-size="commentPage.pageSize"
                         :page-sizes="commentPage.pageSizes"
                         :current-page="commentPage.currentPage"
                         :total="commentPage.total"
                         :layout="commentPage.layout"
                         @current-change="commentCurrentChange"
                         @size-change="commentSizeChange">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane label="点赞列表" name="like">
          <el-table :data="postLikeData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="likeTime" label="点赞时间" width="200"></el-table-column>
            <el-table-column align="center" prop="nickname" label="点赞用户Full Name"></el-table-column>
            <el-table-column align="center" prop="realname" label="点赞用户Birth Name"></el-table-column>
          </el-table>
          <el-pagination :page-size="postLikePage.pageSize"
                         :page-sizes="postLikePage.pageSizes"
                         :current-page="postLikePage.currentPage"
                         :total="postLikePage.total"
                         :layout="postLikePage.layout"
                         @current-change="postLikeCurrentChange"
                         @size-change="postLikeSizeChange">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane label="收藏列表" name="favorite">
          <el-table :data="postFavoriteData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="favoriteTime" label="收藏时间" width="200"></el-table-column>
            <el-table-column align="center" prop="favoriteBy" label="收藏用户Full Name"></el-table-column>
            <el-table-column align="center" prop="favoriteByRealname" label="收藏用户Birth Name"></el-table-column>
          </el-table>
          <el-pagination :page-size="postFavoritePage.pageSize"
                         :page-sizes="postFavoritePage.pageSizes"
                         :current-page="postFavoritePage.currentPage"
                         :total="postFavoritePage.total"
                         :layout="postFavoritePage.layout"
                         @current-change="postFavoriteCurrentChange"
                         @size-change="postFavoriteSizeChange">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="举报列表" v-if="permissions.complaint_audited_list" name="complaint" class="complaint">
          <el-table :data="postComplaintData" stripe tooltip-effect="dark">
            <el-table-column align="center" prop="reason" label="举报描述" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="complainedBy" label="举报者Full Name" width="140"></el-table-column>
            <el-table-column align="center" prop="complainedByRealname" label="举报者Birth Name" width="140"></el-table-column>
            <el-table-column align="center" prop="label" label="举报分类"></el-table-column>
            <el-table-column align="center" label="举报附件">
              <template slot-scope="scope">
                <a v-if="scope.row.hasAttachment" href="javascript:void(0);" @click="thumbnailDetail(scope.row.handleResult,scope.row.id)" class="list-button">附件详情</a>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="content" label="被举报内容" show-overflow-tooltip="" width="150"></el-table-column> -->
            <!-- <el-table-column align="center" prop="targetType" label="被举报内容类别"></el-table-column> -->
            <el-table-column align="center" prop="complainedTo" label="被举报者Full Name" width="160"></el-table-column>
            <el-table-column align="center" prop="complainedToRealname" label="被举报者Birth Name" width="160"></el-table-column>
            <el-table-column align="center" prop="complainedTime" label="举报时间"></el-table-column>
            <el-table-column align="center" prop="handleResult" label="状态"></el-table-column>
          </el-table>
          <el-pagination :page-size="postComplaintPage.pageSize"
                         :page-sizes="postComplaintPage.pageSizes"
                         :current-page="postComplaintPage.currentPage"
                         :total="postComplaintPage.total"
                         :layout="postComplaintPage.layout"
                         @current-change="postComplaintCurrentChange"
                         @size-change="postComplaintSizeChange">
          </el-pagination>
          <el-dialog title="附件详情" :visible.sync="unhandledThumbnailsVisible" width="40%" class="handle-dialog">
            <div v-for="(item, index) in thumbnails" :key="index">
              <img v-if="item" :src="item" class="handle-dialog-img">
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>

    </basic-container>
    <el-dialog
      title="下架"
      :visible.sync="banDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="down-dialog-item-label">下架原因</el-label>
          <el-input v-model="banDialogComment"></el-input>
        </div>
        <!-- <div>
          <el-checkbox class="down-dialog-item-label" v-model="banDialogIsSendWx">是否发送消息通知</el-checkbox>
          <el-input type="textarea" :rows="3" v-if="banDialogIsSendWx" v-model="banDialogSendWxMessage" placeholder="消息"></el-input>
        </div> -->
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="banDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDownSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPost, fetchPostCommentList } from '@/api/post/post';
import { putComment } from '@/api/post/comment';
import { getAttachment } from '@/api/admin/complaints';
import postLikeList from '@/mixins/post/like-list';
import postTipList from '@/mixins/post/tip-list';
import postFavoriteList from '@/mixins/post/favorite-list';
import postComplaintList from '@/mixins/post/complaint-list';
import complaintHandleResultEnum from '@/common/enums/complaintHandleResultEnum';
import {mapGetters} from "vuex";
import { globalCircleIds } from '@/const/globalCircles'

export default {
  mixins: [postLikeList, postFavoriteList, postComplaintList, postTipList],
  data() {
    return {
      id: 0,
      targetType: 0, // 帖子
      activeName: "detail",
      isGlobal: false,
      postDetail:{
        id: undefined,
        title: "",
        titleEn: "",
        contentType: undefined,
        content: "",
        contentEn: "",
        postedBy: undefined,
        postedByName: "",
        tagName: "",
        status: "",
        isActive: "",
        commentCount: 0,
        favoriteCount: 0,
        postTime: "",
        themeTagName: "",
        circleName: '',
        banComment: "",
        isVideo: false,
        photos: [],
        playerOption: {
          height: '380',
          autoplay: false,
          muted: false,
          loop: false,
          language: 'zh-CN',
          playbackRates: [1.0, 1.5, 2.0],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          sources: [{
            src: '',
          }],
        },
      },
      // 评论详情窗口
      commentData: [],
      commentPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
        pageSizes: [10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper"
      },
      isBindDownloadEvent: false,
      unhandledThumbnailsVisible: false,
      unhandledVideolsVisible: false,
      thumbnails: undefined,
      banDialogVisible: false,
      banDialogComment: "",
      banDialogIsSendWx: false,
      banDialogSendWxMessage: "",
      banDialogRow: 0,
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  async mounted() {
    await this.initDetail(this.$route.params.id)
  },
  filters: {
    formatDefaultlVal(val) {
      return !!val ? val : '--';
    },
  },
  methods: {
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    onTabShow(tab) {
      switch (tab.name) {
        case 'comment':
          this.getCommentList();
          break;
        case 'like':
          this.initPostLike();
          break;
        case 'favorite':
          this.initPostFavorite();
          break;
        case 'complaint':
          this.initPostComplaint();
          break;
        case 'tip':
          this.initPostTip();
          break;
      }
    },
    getCommentList(){
      // 获取帖子的评论列表
      let params = {
        current: this.commentPage.currentPage,
        size: this.commentPage.pageSize,
        postId: this.id
      }
      fetchPostCommentList(params).then(response => {
        if (response.data.data != null) {
          this.commentData = response.data.data.records
          this.commentData.forEach(comment => {
            comment.commentByName = comment.commentBy.name
            comment.commentByRealname = comment.commentBy.memberType === 1
              ? comment.commentBy.relatedPersonalRealname
              : comment.commentBy.realname;
            if (comment.commentTo) {
              comment.commentToName = comment.commentTo.name;
              comment.commentToRealname = comment.commentTo.realname;
            } else {
              comment.commentToName = '--';
              comment.commentToRealname = '--';
            }
          })
          this.commentPage.total = response.data.data.total
        } else  {
          this.commentData = null
          this.commentPage.total = 0
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取该帖子的评论列表失败',
          type: 'error'
        })
      })
    },
    commentCurrentChange(val) {
      this.commentPage.currentPage = val;
      this.getCommentList();
    },
    commentSizeChange(val) {
      this.commentPage.pageSize = val;
      this.getCommentList();
    },
    thumbnailDetail(handleResult, id) {
      this.unhandledThumbnailsVisible = handleResult !== 0
      getAttachment(id).then(response => {
        this.thumbnails = response.data.data
      })
    },
    viewVideo() {
      this.unhandledVideolsVisible = true;
    },
    clickLink(linkUrl) {
      window.open(linkUrl);
    },
    async initDetail(id) {
      const response = await getPost(id);
      if (response.status == 200) {
        this.formatPostDetail(response.data.data);
      } else {
        this.$message({
          showClose: true,
          message: '无法查看该帖子详情',
          type: 'error'
        });
      }
    },
    formatPostDetail(data) {
      this.id = data.id;
      // 判断是不是默认圈子
      if (globalCircleIds.indexOf(data.circleId) > -1) {
        this.isGlobal = true;
      }
      // 帖子详情格式化
      this.postDetail.id = data.id
      this.postDetail.title = data.title;
      this.postDetail.titleEn = data.titleEn;
      this.postDetail.contentType = data.contentType;
      this.postDetail.content = data.content;
      this.postDetail.contentEn = data.contentEn;
      if (!data.postedBy) this.postDetail.postedByName = "--";
      else if (!data.postedBy.name) this.postDetail.postedByName = "--";
      else {
        this.postDetail.postedByName = data.postedBy.name;
        const isOfficial = data.postedBy.memberType === 1;
        this.postDetail.postedByRealname = isOfficial
          ? data.postedBy.relatedPersonalRealname
          : data.postedBy.realname;
        this.postDetail.postedBy = data.postedBy;
      }

      if (!data.commentCount) this.postDetail.commentCount = 0;
      else this.postDetail.commentCount = data.commentCount;

      this.postDetail.favoriteCount = data.favoriteCount || 0;
      this.postDetail.likeCount = data.likeCount || 0;
      this.postDetail.viewedCount = data.viewedCount || 0;
      this.postDetail.postTime = data.postTime;

      this.postDetail.banComment = data.banComment || "--";
      if (data.isActive === 1) {
        this.postDetail.publishStatus = '帖子已删除';
      } else if (data.isBanned) {
        this.postDetail.publishStatus = '已下架';
        if (data.complaintReason) {
          this.postDetail.banComment = data.complaintHandleResult === complaintHandleResultEnum.HANDLED_AUTO ? '举报审核自动下架' : data.complaintReason;
        }
      } else {
        this.postDetail.publishStatus = data.publishStatus === 1 ? '已发布' : '草稿';
      }

      this.postDetail.themeTagName = data.themeTagName;
      this.postDetail.postTags = data.postTags;
      this.postDetail.postLinks = data.postLinks;
      this.postDetail.coverImg = data.coverImg;
      this.postDetail.tags = [...new Set(data.postTags.map(item => {return item.tagName}))].join('、');
      this.postDetail.parentTags = [...new Set(data.postTags.map(item => {return item.parentTagName}))].join('、');
      this.postDetail.circleName = data.circleName;

      if (data.attachments && data.attachments[0]) {
        this.isVideo = data.attachments[0].mediaType == 2;
        if (this.isVideo) {
          const video = data.attachments[0];
          const src = !video.convertStreamUrl ? video.attachmentUrl : video.convertStreamUrl;
          this.postDetail.playerOption.sources = [{ src }];
        } else {
          this.postDetail.photos = data.attachments.map(item => { return item.thumbnailUrl });
        }
      }
    },
    getPostCommentDTO(row, inputIsBanned){
      let postCommentDTO= {
        id: row.id,
        isBanned: inputIsBanned,
      }
      return postCommentDTO
    },
    handleUp(row, index) {
      // 上架功能
      let postCommentDTO = this.getPostCommentDTO(row, 0)
      let _this = this
      this.$confirm('是否确认上架内容为"' + row.content + '"'+ '的评论?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return putComment(postCommentDTO);
      }).then(() => {
        this.getCommentList()
        _this.$message({
          showClose: true,
          message: '上架成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    handleDown(row, index) {
      this.banDialogRow = row;
      this.banDialogComment = "";
      this.banDialogIsSendWx = false;
      this.banDialogSendWxMessage = "你发布的评论未能通过审核，请重新发布内容";
      this.banDialogVisible = true;
    },
    handleDownSubmit() {
      if (!this.banDialogComment) {
        this.$message({
          showClose: true,
          message: '下架原因不能为空',
          type: 'error'
        });
        return;
      }

      if (this.banDialogIsSendWx && !this.banDialogSendWxMessage) {
        this.$message({
          showClose: true,
          message: '发送消息不能为空',
          type: 'error'
        });
        return;
      }

      let postCommentDTO = this.getPostCommentDTO(this.banDialogRow, 1);
      postCommentDTO.banComment = this.banDialogComment;
      postCommentDTO.isSendWxMessage = this.banDialogIsSendWx;
      postCommentDTO.wxMessage = this.banDialogSendWxMessage;
      putComment(postCommentDTO)
        .then(response => {
          this.getCommentList();
          this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
          });
        })
        .catch(function (err) {})
        .finally(() => {
          this.banDialogVisible = false;
        });
    },
  },
}
</script>

<style lang="scss" scoped>

.post-detail {
  .post-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
    .list-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
    .handle-dialog {
      display: flex;
      flex-direction: column;
      &-item {
        width: 500px;
        display: flex;
        margin-top: 20px;
        flex-direction: row;
        &-label {
          text-align: center;
          font-size: 14px;
          width: 110px;
          line-height: 36px;
          padding: 0 5px;
        }
        &-input {
          font-size: 14px;
          width: 300px;
          height: 36px;
        }
      }
      &-footer{
        display: flex;
        flex-direction: row;
        padding: 20px 0px;
        &-save {
          padding: 8px 12px;
          position: absolute;
          right: 90px;
        }
        &-cancel {
          padding: 8px 12px;
          position: absolute;
          right: 10px;
          margin-right: 10px;
        }
      }
      &-img {
        max-width: 500px;
      }
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-poster {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.post-cover-image {
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  cursor: pointer;
  img {
    padding: 5px;
    width: 52px;
    height: 52px;
    object-fit: cover;
    max-width: 100%;
  }
}

.post-content-video {
  display: flex;
  width: fit-content;
  padding: 10px;
  cursor: pointer;
  img {
    width: 356px;
    height: 200px;
    object-fit: cover;
    max-width: 100%;
  }
}

.post-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    color: #105b89;
    text-decoration: underline;
  }
  /deep/ p {
    color: #000000;
  }
  /deep/ .mc-file {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    padding: 3px;
    line-height: 20px;
    text-decoration: none;
    color: #01396B;
    .mc-file-icon {
      background: url(../../../static/images/editor/file.svg) no-repeat center;
      background-size: 80%;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  /deep/ table {
    margin: 1em 0;
  }
}

.complaint {
  .list-button {
    color: #409EFF;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
  }
  .handle-dialog {
    display: flex;
    flex-direction: column;
    &-item {
      width: 500px;
      display: flex;
      margin-top: 20px;
      flex-direction: row;
      &-label {
        text-align: center;
        font-size: 14px;
        width: 110px;
        line-height: 36px;
        padding: 0 5px;
      }
      &-input {
        font-size: 14px;
        width: 300px;
        height: 36px;
      }
    }
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
    &-img {
      max-width: 500px;
    }
  }
}

.post-content-text {
  word-break: break-all;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
